import {
  EmailParam,
  OperationGroup,
  TaskInstanceParam,
  TaskSearchParams,
} from "types";
import { httpCollection } from "us.helper/http/collection";

export default {
  tasks: {
    search: (params: TaskSearchParams): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "operations",
            "tasks/-1",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  task: {
    save: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "operations",
            "task",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    run: (taskId: number): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "operations",
            `run/task/${taskId}`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    delete: (taskId: number): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "operations",
            `task/${taskId}`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  pendingTasks: {
    get: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "operations",
            "pendingtasks",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  groups: {
    get: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "operations",
            "groups",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    save: (params: OperationGroup): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "operations",
            "group",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    update: (params: OperationGroup): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "operations",
            `group`,
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    delete: (params: OperationGroup): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "operations",
            `group/${params.groupId}`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  taskHistory: {
    get: (taskId: number): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.getById(
            "operations",
            "task/history",
            taskId
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  instanceHistory: {
    get: (taskId: number): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.getById(
            "operations",
            "instance/history",
            taskId
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  taskInstance: {
    post: (params: TaskInstanceParam): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "operations",
            "instance",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  users: {
    get: (): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "userservice",
            "users",
            {}
          );
          if (status == 200) {
            resolve({ data, status });
          } else {
            reject({ data, status });
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  operationsHandlers: {
    get: (): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "operations",
            "handlers",
            {}
          );
          if (status == 200) {
            resolve({ data, status });
          } else {
            reject({ data, status });
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  email: {
    post: (params: EmailParam): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "operations",
            "email/send",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  scripts: {
    get: (): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "operations",
            "scripts",
            {}
          );
          if (status == 200) {
            resolve({ data, status });
          } else {
            reject({ data, status });
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
